import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fontSize", "height", "lineHeight", "hasIcon", "hasAnyBorder", "cornerToRound", "active"],
  _excluded2 = ["fontSize", "height", "lineHeight", "width", "hasAnyBorder", "onlyLeftAndRightBorders", "cornerToRound", "disabled", "active"];
import styled from 'foundations-theming/utils';
import { css } from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import { WEB_FONT_MEDIUM, WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import { INACTIVE_BORDER_COLOR, INACTIVE_FONT_COLOR, ACTIVE_BORDER_COLOR, ACTIVE_FONT_COLOR, SMALL_CURVE_RADIUS } from './constants';

// Prevent extra wrappers from being relatively positioned
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledUIButtonGroup = styled(UIButtonGroup).withConfig({
  displayName: "styledButtons__StyledUIButtonGroup",
  componentId: "vtcqjv-0"
})([".hs-private.hs-private.hs-private & > *{position:static;}"]);
const cssForCornerToRound = cornerToRound => {
  switch (cornerToRound) {
    case 'left top':
    case 'top left':
      return `border-top-left-radius: ${SMALL_CURVE_RADIUS}px`;
    case 'left bottom':
    case 'bottom left':
      return `border-bottom-left-radius: ${SMALL_CURVE_RADIUS}px`;
    case 'right top':
    case 'top right':
      return `border-top-right-radius: ${SMALL_CURVE_RADIUS}px`;
    case 'bottom right':
    case 'right bottom':
      return `border-bottom-right-radius: ${SMALL_CURVE_RADIUS}px`;
    default:
      return '';
  }
};
const fontStyles = css(["color:", ";"], props => props.use === 'tertiary' ? ACTIVE_FONT_COLOR : INACTIVE_FONT_COLOR);
const borderStyles = css(["", " ", " border-color:", ";border-radius:0;", ""], props => !props.hasAnyBorder ? `border: none;` : '', props => props.onlyLeftAndRightBorders && props.hasAnyBorder ? `border-width: 0 0 0 1px;` : `border-width: 1px;`, props => props.use === 'tertiary' ? ACTIVE_BORDER_COLOR : INACTIVE_BORDER_COLOR, props => cssForCornerToRound(props.cornerToRound));
const overrideFont = css(["& > span{font-family:", ";font-weight:", ";}"], WEB_FONT_MEDIUM, WEB_FONT_MEDIUM_WEIGHT);

// Beat specificity of https://git.hubteam.com/HubSpot/UIComponents/blob/1b4efeb9fedbe4e97e7f4b679afe5f9a8fff003e/HubStyle/static-2.9708/stylesheets/hubstyle/_buttons.sass#L318-L324
const overrideInnerIconMargin = css(["&.uiButton.uiButton > *{margin:0;}"]);
export const SHIFT_TOOLBAR_ICON_UP_CLASSNAME = 'shift-toolbar-icon-up';
const shiftIconToolbarUpClassnameStyles = css([".", "{position:relative;top:-1px;}"], SHIFT_TOOLBAR_ICON_UP_CLASSNAME);
export const StyledHandleButton = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest));
}).withConfig({
  displayName: "styledButtons__StyledHandleButton",
  componentId: "vtcqjv-1"
})([".hs-private.hs-private.hs-private &{", " ", " ", ";}.hs-private.hs-private.hs-private &.uiButton.uiButton{", " padding-top:0;padding-bottom:0;padding-left:6px;padding-right:", "px;position:relative;", " ", "}.hs-private.hs-private.hs-private &.uiButton.uiButton:hover{", "}.hs-private.hs-private.hs-private &.uiButton.uiButton > .toolbar-handle-label{margin-left:6px;}"], overrideInnerIconMargin, overrideFont, shiftIconToolbarUpClassnameStyles, props => `
      height: ${props.height}px;
      font-size: ${props.fontSize}px;
      line-height: ${props.lineHeight}px;
    `, props => props.hasIcon ? 6 : 0, fontStyles, borderStyles, borderStyles);
export const StyledIconButton = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, rest));
}).withConfig({
  displayName: "styledButtons__StyledIconButton",
  componentId: "vtcqjv-2"
})([".hs-private.hs-private.hs-private &{", ";}.hs-private.hs-private.hs-private &.uiButton.uiButton{", " ", " padding:0;position:relative;", " ", " ", "}.hs-private.hs-private.hs-private &.uiButton.uiButton:hover{", "}.hs-private.hs-private.hs-private &.uiButton.uiButton .disabled-icon{color:", ";}"], shiftIconToolbarUpClassnameStyles, props => `
      height: ${props.height}px;
      font-size: ${props.fontSize}px;
      line-height: ${props.lineHeight}px;
    `, props => props.width ? `width: ${props.width}px;` : '', fontStyles, borderStyles, props => props.disabled && `cursor: not-allowed;`, borderStyles, ({
  theme
}) => theme.color['do-not-use-flint']);